import { Component, OnInit } from '@angular/core';
import { NeproseService } from '../services/neprose.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  currentPage: string

  seoData: SeoSocialShareData = {
    title:  'Neprose - Profile',
    description: 'Your profile and properties',
    image: environment.url+'/assets/logo.png'
  };

  constructor( private route: ActivatedRoute, private router: Router, private seo: SeoSocialShareService) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
    this.currentPage = this.route.snapshot.params.page
  }

  selectPage(page){
    this.currentPage = page
    this.router.navigate(['/profile/'+page])
  }

}
